import { DateRangePicker } from "./DateRangePicker";
import { useI18n } from "../i18n/I18nProvider";

/** All single dates and date-times use the same agenda as guided setup. */
export function AgendaDateField({ value, onChange, label, type = "date", min, max, initialDate, tripEndDate, disabled, readOnly }: {
  value: string; onChange: (value: string) => void; label: string;
  type?: "date" | "datetime-local"; min?: string; max?: string; initialDate?: string; tripEndDate?: string;
  className?: string; disabled?: boolean; readOnly?: boolean;
}) {
  const { language } = useI18n(), date = value.slice(0, 10), time = value.includes("T") ? value.slice(11, 16) : "";
  const timeLabel = language === "it" ? "Ora" : language === "es" ? "Hora" : "Time";
  return <fieldset className="agenda-date-field" disabled={disabled || readOnly} style={{ border: 0, padding: 0, margin: 0, minWidth: 0 }}>
    <DateRangePicker single start={date} end={date} startLabel={label} endLabel="" min={min?.slice(0, 10)} max={max?.slice(0, 10)} initialDate={initialDate} tripEndDate={tripEndDate}
      onChange={next => onChange(type === "datetime-local" ? `${next}T${time || "00:00"}` : next)} />
    {type === "datetime-local" && <input className="input" aria-label={timeLabel} type="time" value={time} disabled={!date || disabled || readOnly} onChange={event => onChange(`${date}T${event.target.value || "00:00"}`)} />}
  </fieldset>;
}
